import React from 'react';
import YetToBeImplemented from '../YetToBeImplemented/YetToBeImplemented';

function CEditModal() {
  return (
    <div>
      <YetToBeImplemented />
    </div>
  );
}

export default CEditModal;
